var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcMembershipStandard24X12 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 12,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.608 0h-7.187a2.42 2.42 0 0 0-2.415 2.414v7.16a2.42 2.42 0 0 0 2.415 2.414h7.164A2.42 2.42 0 0 0 24 9.574V2.402a2.397 2.397 0 0 0-2.404-2.39",
  fill: "#21AB73"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.602.012H2.415A2.42 2.42 0 0 0 0 2.426v7.16A2.42 2.42 0 0 0 2.415 12h7.176a2.42 2.42 0 0 0 2.415-2.414V2.414A2.4 2.4 0 0 0 9.602.012Z",
  fill: "#192D82"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.478 9.504a.782.782 0 1 1-1.564 0 .782.782 0 0 1 1.564 0Z",
  fill: "#2E80FF"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.53 6.764c-.258 0-.514.163-.643.338-.408.467-.945.84-1.656.84a1.952 1.952 0 0 1-1.96-1.936c0-1.038.84-1.936 1.96-1.936.711 0 1.248.362 1.656.84.129.163.385.338.642.338.467 0 .793-.35.793-.735a.818.818 0 0 0-.128-.455C8.552 3.125 7.526 2.52 6.242 2.52c-1.995 0-3.547 1.528-3.547 3.499 0 1.97 1.552 3.498 3.547 3.498 1.284 0 2.31-.595 2.952-1.528a.83.83 0 0 0 .128-.466c0-.385-.326-.735-.793-.735",
  fill: "#fff"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M3.478 9.504a.782.782 0 1 1-1.564 0 .782.782 0 0 1 1.564 0Z",
  fill: "#2E80FF"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M18.002 2.496a.782.782 0 0 0-.781.78v5.412a.782.782 0 0 0 1.563 0V3.277a.782.782 0 0 0-.782-.781Z",
  fill: "#fff"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M21.503 5.983a.782.782 0 0 0-.782-.782h-5.426a.782.782 0 1 0 0 1.563h5.426c.431 0 .782-.35.782-.781Z",
  fill: "#fff"
})));
export default SvgIcMembershipStandard24X12;